import { render, staticRenderFns } from "./FiltroPeriodoPedidos.vue?vue&type=template&id=ca7fc118&"
import script from "./FiltroPeriodoPedidos.vue?vue&type=script&lang=js&"
export * from "./FiltroPeriodoPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports